<template>
  <div>
    <hr>

    <DataTable
      :data="facturadets"
      :columns="columnas"
      idField="idFacturaDet"
      :mostrarBotonTodos="false"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarEditar="p_estadoFactura === 'PENDIENTE'"
      :mostrarBotonNuevo="p_estadoFactura === 'PENDIENTE'"
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idFacturaDet)"
    >
      <template #footer-extra>
        <tr class="table-secondary fw-bold">
          <td :colspan="columnas.length - 1" class="text-end">Sub-Total:</td>
          <td class="text-end">{{ totalPrecioTotal }}</td>
          <td v-if="p_estadoFactura === 'PENDIENTE'"></td>
        </tr>
      </template>
    </DataTable>

    <!-- Tabla de impuestos -->
    <div class="d-flex justify-content-end mt-2">
      <div style="flex: 0 1 50%;">
        <table class="table table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th>Impuesto</th>
              <th class="text-end">Base Imponible</th>
              <th class="text-end">Monto Impuesto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="impuesto in facturaimps" :key="impuesto.idFacturaImp">
              <td>{{ impuesto.impuestoNombre }}</td>
              <td class="text-end">{{ impuesto.baseImponible }}</td>
              <td class="text-end">{{ impuesto.montoImpuesto }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td colspan="2" class="text-end">Sub-Total Impuestos:</td>
              <td class="text-end">{{ totalImpuestos }}</td>
            </tr>
            <tr class="table-secondary">
              <td colspan="2" class="text-end texto-grande">TOTAL:</td>
              <td class="text-end texto-grande">{{ totalPrecioTotal + totalImpuestos }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Modal detalle -->
    <div class="modal fade" id="ventanaModalDet" tabindex="-1"
      aria-labelledby="ventanaModalDetLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
<form @submit.prevent="guardarFacturaDet" novalidate>
  <div class="modal-body">

    <!-- IdFacturaDet (solo edición) -->
<!--
    <div class="mb-3" v-if="btnEditar">
      <div class="row align-items-center">
        <div class="col-2">
          <label class="form-label fw-bold">IdFacturaDet</label>
        </div>
        <div class="col-10">
          <input type="text" class="form-control" v-model="datoFacturaDet.idFacturaDet" disabled>
        </div>
      </div>
    </div>
-->

    <!-- Código -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-2">
          <label class="form-label fw-bold">Código <span class="text-danger"></span></label>
        </div>
        <div class="col-10">
          <input type="text" class="form-control" v-model="datoFacturaDet.codigo" disabled>
          <div class="invalid-feedback">El código es obligatorio.</div>
        </div>
      </div>
    </div>

    <!-- Descripción -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-2">
          <label class="form-label fw-bold">Descripción <span class="text-danger"></span></label>
        </div>
        <div class="col-10">
          <textarea
            class="form-control"
            :class="{ 'is-invalid': errores.descripcion }"
            v-model="datoFacturaDet.descripcion"
            @input="datoFacturaDet.descripcion = datoFacturaDet.descripcion.toUpperCase()"
            rows="2"
            disabled
          ></textarea>
          <div class="invalid-feedback">La descripción es obligatoria.</div>
        </div>
      </div>
    </div>

    <!-- Cantidad / Precio / Subtotal -->
    <div class="mb-3">
      <div class="row align-items-center">

        <!-- Cantidad -->
        <div class="col-2">
          <label class="form-label fw-bold">Cantidad <span class="text-danger">*</span></label>
        </div>
        <div class="col-2">
          <input
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errores.cantidad }"
            v-model.number="datoFacturaDet.cantidad"
            min="1"
            step="1"
            @input="calcularSubtotal"
          >
          <div class="invalid-feedback">Debe ser mayor a 0.</div>
        </div>

        <!-- Precio Unitario -->
        <div class="col-2">
          <label class="form-label fw-bold">Precio Unit. <span class="text-danger">*</span></label>
        </div>
        <div class="col-2">
          <input
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errores.precioUnitario }"
            v-model.number="datoFacturaDet.precioUnitario"
            min="0.01"
            step="0.01"
            @input="calcularSubtotal"
          >
          <div class="invalid-feedback">Debe ser mayor a 0.</div>
        </div>

        <!-- Subtotal (calculado automáticamente) -->
        <div class="col-2">
          <label class="form-label fw-bold">Subtotal</label>
        </div>
        <div class="col-2">
          <input
            type="number"
            class="form-control bg-light"
            v-model="datoFacturaDet.subtotal"
            disabled
          >
        </div>

      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <small class="text-muted me-auto">
      <span class="text-danger">*</span> Campos obligatorios
    </small>
    <button
      type="submit"
      class="btn btn-light"
      v-if="btnCrear || btnEditar"
    >
      <i class="material-icons" style="font-size:32px; color:blue; cursor:pointer">save</i>
    </button>
  </div>

</form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from '@/services/api'
import * as $ from 'jquery'
window['$'] = $
window['jQuery'] = $
import swal from 'sweetalert'

export default {
  name: 'FacturaDetalle',

  components: { DataTable },

  props: {
    p_idFactura:     { type: Number, required: true },
    p_estadoFactura: { type: String, required: true },
  },

  data() {
    return {
      facturadets:    [],
      facturaimps:    [],
      datoFacturaDet: {},
      titulo:         '',
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,

      columnas: [
        { field: 'codigo',         label: 'Código' },
        { field: 'descripcion',    label: 'Descripción' },
        { field: 'cantidad',       label: 'Cantidad' },
        { field: 'precioUnitario', label: 'Precio Unitario' },
        { field: 'subtotal',       label: 'Subtotal' },
      ],

      errores: {
        codigo:         false,
        descripcion:    false,
        cantidad:       false,
        precioUnitario: false,
      },	  
    }
  },

  computed: {
    totalPrecioTotal() {
      return this.facturadets.reduce(
        (acc, d) => acc + d.cantidad * d.precioUnitario, 0)
    },
    totalImpuestos() {
      return this.facturaimps.reduce(
        (acc, i) => acc + i.montoImpuesto, 0)
    },
  },

  watch: {
    p_idFactura(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDataTodos()
        this.getImpuestos()
      }
    },
  },

  mounted() {
    this.getDataTodos()
    this.getImpuestos()
  },

  methods: {
    getDataTodos() {
      api.get('/vwfacturadets/idfactura/' + this.p_idFactura)
        .then(r => { this.facturadets = r.data.reverse() })
        .catch(e => console.error('Error cargando detalles:', e))
    },

    getImpuestos() {
      api.get('/vwfacturaimps/idfactura/' + this.p_idFactura)
        .then(r => { this.facturaimps = r.data })
        .catch(e => console.error('Error cargando impuestos:', e))
    },

    validarFormDet() {
      const fields = ['descripcion', 'cantidad', 'precioUnitario', 'subtotal']
      return validarForm(this.datoFacturaDet, fields, fields)
    },

    async guardarFacturaDet() {
      if (this.validarFormDet() === 1) {
        try {
          if(!this.datoFacturaDet.idFactura) {
            this.datoFacturaDet.idFactura = this.p_idFactura
          }
          await api.post('/facturadets', this.datoFacturaDet)
          $('#ventanaModalDet').modal('hide')
          swal('Correcto!', 'Detalle creado exitosamente!', 'success')
          this.getDataTodos()
          this.getImpuestos()
        } catch (error) {
          swal('Error!', 'Intentelo de nuevo!', 'error')
        }
      }
    },

    abrirModalCrear() {
      this.modalWindow    = true
      this.datoFacturaDet = {}
      this.titulo         = 'Crear Detalle Factura'
      this.btnCrear       = true
      this.btnEditar      = false
      this.$nextTick(() => $('#ventanaModalDet').modal('show'))
    },

    abrirModalEditar(idFacturaDet) {
      this.modalWindow = true
      this.titulo      = 'Editar Detalle Factura'
      this.btnCrear    = false
      this.btnEditar   = true
      if (idFacturaDet != null) {
        api.get('/vwfacturadets/' + idFacturaDet)
          .then(r => { this.datoFacturaDet = r.data })
      }
      this.$nextTick(() => $('#ventanaModalDet').modal('show'))
    },
	
  // Calcula subtotal automáticamente
  calcularSubtotal() {
    const cantidad = parseFloat(this.datoFacturaDet.cantidad) || 0;
    const precio   = parseFloat(this.datoFacturaDet.precioUnitario) || 0;
    this.datoFacturaDet.subtotal = parseFloat((cantidad * precio).toFixed(2));
  },

  // Valida el formulario antes de guardar
  validar() {
    this.errores.codigo         = !this.datoFacturaDet.codigo?.trim();
    this.errores.descripcion    = !this.datoFacturaDet.descripcion?.trim();
    this.errores.cantidad       = !this.datoFacturaDet.cantidad || this.datoFacturaDet.cantidad <= 0;
    this.errores.precioUnitario = !this.datoFacturaDet.precioUnitario || this.datoFacturaDet.precioUnitario <= 0;
    return !Object.values(this.errores).some(e => e);
  },
  },
}
</script>

<style scoped>
.texto-grande {
  font-size: 18px;
  color: #0000FF;
}
</style>